import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const serviceDeskServiceDetailsWithoutProjectRoute: InvariantJiraRoute = {
	name: 'servicedesk-service-details-without-project',
	path: '/jira/servicedesk/services/:serviceAri',
};
